/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for financial group permission
 * @export
 * @interface FinancialGroupPermissionResponse
 */
export interface FinancialGroupPermissionResponse {
    /**
     * Unique identifier of the planning permission
     * @type {string}
     * @memberof FinancialGroupPermissionResponse
     */
    id?: string;
    /**
     * Unique identifier of the person
     * @type {string}
     * @memberof FinancialGroupPermissionResponse
     */
    personId?: string;
    /**
     * Firstname and lastname of the person
     * @type {string}
     * @memberof FinancialGroupPermissionResponse
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FinancialGroupPermissionResponse
     */
    permissions?: Array<FinancialGroupPermissionResponsePermissionsEnum>;
}


/**
 * @export
 */
export const FinancialGroupPermissionResponsePermissionsEnum = {
    CreateBills: 'CREATE_BILLS',
    AddCancelTransactions: 'ADD_CANCEL_TRANSACTIONS',
    AddPaymentTransactions: 'ADD_PAYMENT_TRANSACTIONS',
    ExportBills: 'EXPORT_BILLS',
    ModifyTransactions: 'MODIFY_TRANSACTIONS'
} as const;
export type FinancialGroupPermissionResponsePermissionsEnum = typeof FinancialGroupPermissionResponsePermissionsEnum[keyof typeof FinancialGroupPermissionResponsePermissionsEnum];


/**
 * Check if a given object implements the FinancialGroupPermissionResponse interface.
 */
export function instanceOfFinancialGroupPermissionResponse(value: object): value is FinancialGroupPermissionResponse {
    return true;
}

export function FinancialGroupPermissionResponseFromJSON(json: any): FinancialGroupPermissionResponse {
    return FinancialGroupPermissionResponseFromJSONTyped(json, false);
}

export function FinancialGroupPermissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialGroupPermissionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'personId': json['personId'] == null ? undefined : json['personId'],
        'name': json['name'] == null ? undefined : json['name'],
        'permissions': json['permissions'] == null ? undefined : json['permissions'],
    };
}

export function FinancialGroupPermissionResponseToJSON(json: any): FinancialGroupPermissionResponse {
    return FinancialGroupPermissionResponseToJSONTyped(json, false);
}

export function FinancialGroupPermissionResponseToJSONTyped(value?: FinancialGroupPermissionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'personId': value['personId'],
        'name': value['name'],
        'permissions': value['permissions'],
    };
}

